import Modal from 'react-modal';
import { useState } from 'react';
import * as d3 from "d3";

import exportSVG from "../noncomponents/exportSVG"
import table from '../assets/data/digitoegankelijkheid/20211116_Droogte matrix_Relaties in getallen uitgedrukt voor digitoegankelijkheid.xlsx'
import exportimg from '../assets/data/images/export.png'


function SVGExport() {

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  const modalStyle = {
    content: {
      top: '100px',
      left: '100px',
      right: 'auto',
      bottom: 'auto',
      width:'400px',
      height:'100px'
      // marginRight: '-50%',
      // transform: 'translate(-50%, -50%)',
    },
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#726f6d';
  }

  function hover(){
    d3.select('.export_text')
      .style('visibility', 'visible');
  }

  function mouseOut(){
    d3.select('.export_text')
      .style('visibility', 'hidden');
  }

  return (
    <div className="svgexport">
      <input
        type='image'
        tabIndex='0'
        onClick={() => exportSVG()}
        onMouseOver={() => hover()}
        onMouseOut={() => mouseOut()}
        style={{ cursor:'pointer' }}
        className='export_image'
        src={exportimg}
        alt='Exporteer deze visualisatie als SVG bestand'
      />
      <p className='export_text'>Exporteer als SVG</p>

    </div>
  );
}

export default SVGExport;
